import { SET_PAGE, SET_ROWS_PER_PAGE, INIT_PAGE } from '../actions/types/index';

const INITIAL_STATE = {
  numPage: 0,
  rowsPerPage: 10
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PAGE:
      return { ...state, numPage: action.payload };
    case SET_ROWS_PER_PAGE:
      return { ...state, rowsPerPage: action.payload, numPage: INITIAL_STATE.numPage };
    case INIT_PAGE:
      return { ...INITIAL_STATE, rowsPerPage: action.payload || INITIAL_STATE.rowsPerPage };
    default:
      return state;
  }
};
